import { Module } from '@/modules/core/app/constants/app.constants';
import { DrillDownRoute, DrillDownPathName } from '@/modules/ta/drilldown/drilldown.constants';
import { ServiceDrilldownRouteConfig } from '@/modules/ta/service/ServiceDrilldownRouteConfig';

export const router = ServiceDrilldownRouteConfig.factory(
  [
    {
      path: `/${DrillDownRoute.DRILLDOWNS}`,
      name: DrillDownPathName.DRILLDOWNS,
      component: () =>
        import(/* webpackChunkName: "drilldowns-page" */ './pages/DataSourceDrilldownsPage.vue'),
    },
  ],
  Module.SERVICE
);
